import React from 'react'

import { JSONContent } from '@tiptap/core'
import classNames from 'classnames'

import {
    RichTextAttributeEditorStyle,
    RichTextAttributeStyle,
} from 'features/views/attributes/editable/RichTextAttribute.css'
import { RichTextValue } from 'features/views/attributes/types'

import { Textarea } from 'ui/components/Textarea'

export const RichTextDefaultValue: React.FC<{
    value: FieldDto['default_value']
    onChange: (value: FieldDto['default_value']) => void
}> = ({ value, onChange }) => {
    const editorRef = React.useRef<any>()

    return (
        <Textarea
            richText={true}
            ref={editorRef}
            size="m"
            autoSize
            value={value?.value?.content ?? ''}
            onChange={(value: JSONContent | null) => {
                const plainTextContent = editorRef.current?.editor?.getText() ?? ''

                const fieldValue: RichTextValue | null =
                    // If the field is empty, set it back to null
                    plainTextContent == ''
                        ? null
                        : {
                              format: 'tiptap',
                              content: value,
                              plainTextContent,
                          }
                onChange({ type: 'constant', value: fieldValue })
            }}
            width="full"
            className={classNames(RichTextAttributeEditorStyle, RichTextAttributeStyle)}
            fieldProps={{
                style: {
                    minWidth: 0,
                },
            }}
        />
    )
}
